// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Dialog_overlay__FDkzQ","open":"Dialog_open__MvAaq","dialog":"Dialog_dialog__yVExh"};